import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const steps = [
  ["01", "Crea tu binder", "Sube tus cartas reales, organizalas como quieras y comparte tu coleccion."],
  ["02", "Marca lo que buscas", "Cardora cruza tus buscadas con cartas publicadas por otros coleccionistas."],
  ["03", "Conecta con confianza", "Coincide en comunidades y eventos, conversa y construye reputacion."]
];

function Home() {
  const hasSession = Boolean(localStorage.getItem("token"));

  return (
    <main className="landing-page">
      <section className="landing-hero">
        <Container className="landing-hero-inner">
          <img className="landing-logo" src="/assets/cardora-logo.png" alt="Cardora" />
          <span className="home-kicker">Comunidad TCG para coleccionistas y tiendas</span>
          <h1>Encuentra las cartas que buscas.</h1>
          <p>
            Convierte tu coleccion en un binder vivo, descubre quien tiene esa carta
            que te falta y conecta alrededor de comunidades y eventos reales.
          </p>
          <div className="landing-actions">
            <Button as={Link} to={hasSession ? "/binder" : "/register"} className="btn-cardora">
              {hasSession ? "Abrir mi binder" : "Crear cuenta gratis"}
            </Button>
            <Button as={Link} to="/" variant="outline-light">Explorar Cardora</Button>
          </div>
        </Container>
      </section>

      <section className="landing-proof-band">
        <Container>
          <div className="landing-proof-copy">
            <span>Tu coleccion deja de estar aislada</span>
            <strong>Cartas reales. Busquedas reales. Personas con las que puedes coincidir.</strong>
          </div>
        </Container>
      </section>

      <section className="landing-section">
        <Container>
          <div className="landing-section-head">
            <span className="home-kicker">Como funciona</span>
            <h2>Del binder al encuentro, sin convertir el hobby en un marketplace.</h2>
          </div>
          <Row className="g-0 landing-steps">
            {steps.map(([number, title, copy]) => (
              <Col md={4} key={number}>
                <article className="landing-step">
                  <span>{number}</span>
                  <h3>{title}</h3>
                  <p>{copy}</p>
                </article>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="landing-community-band">
        <Container>
          <Row className="g-5 align-items-center">
            <Col lg={6}>
              <span className="home-kicker">Para coleccionistas</span>
              <h2>Tu binder es tambien tu forma de conectar.</h2>
              <p>
                Muestra cartas en exhibicion, publica tus buscadas, recibe intereses
                y descubre coincidencias basadas en lo que cada persona tiene de verdad.
              </p>
              <div className="landing-inline-actions">
                <Button as={Link} to="/reports" variant="outline-dark">Ver actividad</Button>
                <Button as={Link} to="/" variant="link">Explorar el feed</Button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="landing-binder-preview" aria-label="Vista conceptual de un binder Cardora">
                {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(slot => (
                  <div className={slot === 4 ? "is-highlighted" : ""} key={slot}>
                    <span>{slot === 4 ? "Tu carta" : "Cardora"}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="landing-store-band">
        <Container>
          <Row className="g-5 align-items-center">
            <Col lg={7}>
              <span className="home-kicker">Para tiendas y comunidades</span>
              <h2>Un espacio digital para mantener activa la comunidad local.</h2>
              <p>
                Publica eventos, productos y comunicados. Reune seguidores y facilita
                que los coleccionistas descubran donde pueden encontrarse e intercambiar.
              </p>
            </Col>
            <Col lg={5} className="landing-store-actions">
              <Button as={Link} to="/communities" className="btn-cardora">Ver comunidades</Button>
              <Button as={Link} to="/stores/register" variant="outline-dark">Registrar una tienda</Button>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="landing-final-cta">
        <Container>
          <img src="/assets/cardora-logo.png" alt="" />
          <h2>Hay una carta buscandote.</h2>
          <p>Empieza por tu binder. Cardora se encarga de encontrar las coincidencias.</p>
          <Button as={Link} to={hasSession ? "/binder" : "/register"} className="btn-cardora">
            {hasSession ? "Volver a mi binder" : "Crear mi perfil"}
          </Button>
        </Container>
      </section>
    </main>
  );
}

export default Home;
